import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SetPassenger } from '../../../actions/currentBooking';


class PassengerDropdown extends PureComponent {

  constructor(props){
    super(props);

    this.state = {
      Adult:1
    }
    this.onPassengerChange = this.onPassengerChange.bind(this);
  }


  componentDidMount(){

    const { iscyoa, SetPassenger, paxnum } = this.props;

    // Initial passenger drop down
    // 1. Set default values for regulars tours and hoho tours
    // 2. Set passengers number from CYOA booking payload
    if(!iscyoa){
     SetPassenger(this.state);
   }else{
     this.setState({"Adult":paxnum} , () => SetPassenger({"Adult":paxnum}));
   }

  }


  onPassengerChange(paxType, direction){

    const { Adult } = this.state;
    const { SetPassenger } = this.props;

    if(!this.props.disabled){
      if(paxType === 'adult'){
        if(direction === 'down'){
          if(Adult > 0) this.setState({Adult: Adult - 1}, () => SetPassenger(this.state));
        }
        if(direction === 'up'){
           if(Adult < 10) this.setState({Adult: Adult + 1}, () => SetPassenger(this.state));
        }
      }
    }
  }

  render(){
    return (
     <div className="row">
        <div className="column small-12">
          <div className="pax-selector-container">
            <div className="pax-selector outline">
               <div className="column small-5 pax-title">

                  <svg xmlns="http://www.w3.org/2000/svg" width="75.315" height="67.558" viewBox="0 0 75 67">
                    <g data-name="Layer 2">
                      <g data-name="Layer 1">
                        <path d="M31.07 57.426H2.072a2 2 0 0 1-1.955-1.577c-.578-2.672 1.02-6.933 3.979-10.6 2.901-3.598 9.582-9.632 21.72-9.632a31.363 31.363 0 0 1 9.636 1.447 2 2 0 0 1-1.228 3.807 27.362 27.362 0 0 0-8.408-1.254c-10.474 0-16.154 5.101-18.607 8.142a15.556 15.556 0 0 0-3.026 5.666H31.07a2 2 0 0 1 0 4z"/>
                        <path d="M25.816 39.617a19.809 19.809 0 1 1 18.665-26.455 2 2 0 0 1-3.767 1.342 15.81 15.81 0 1 0-14.898 21.113 15.67 15.67 0 0 0 6.739-1.503 2 2 0 0 1 1.707 3.618 19.637 19.637 0 0 1-8.446 1.885zM61.666 67.558H26.44a2 2 0 0 1-1.955-1.578c-.578-2.672 1.02-6.932 3.979-10.6 2.902-3.597 9.582-9.632 21.721-9.632 10.383 0 16.776 4.37 20.311 8.034a2 2 0 0 1-2.879 2.778c-2.997-3.107-8.454-6.811-17.432-6.811-10.475 0-16.155 5.103-18.608 8.144a15.546 15.546 0 0 0-3.026 5.665h33.115a2 2 0 0 1 0 4z"/>
                        <path d="M50.185 49.749A19.809 19.809 0 1 1 69.993 29.94a19.83 19.83 0 0 1-19.807 19.809zm0-35.617A15.809 15.809 0 1 0 65.993 29.94a15.827 15.827 0 0 0-15.807-15.808z"/>
                        <path d="M50.084 41.723a10.12 10.12 0 0 1-9.595-6.934 2 2 0 1 1 3.793-1.27 6.107 6.107 0 0 0 11.755-.536 2 2 0 1 1 3.895.91 10.208 10.208 0 0 1-9.848 7.83zM73.315 67.558h-5.322a2 2 0 1 1 0-4h3.322V60.18a2 2 0 0 1 4 0v5.378a2 2 0 0 1-2 2zM25.201 31.59a10.116 10.116 0 0 1-9.594-6.935 2 2 0 0 1 3.793-1.267 6.124 6.124 0 0 0 5.8 4.203 6.582 6.582 0 0 0 6.386-4.45 2 2 0 1 1 3.865 1.03 10.541 10.541 0 0 1-10.25 7.42zM31.07 57.426H2.072a2 2 0 0 1-1.955-1.577c-.578-2.672 1.02-6.933 3.979-10.6 2.901-3.598 9.582-9.632 21.72-9.632a31.363 31.363 0 0 1 9.636 1.447 2 2 0 0 1-1.228 3.807 27.362 27.362 0 0 0-8.408-1.254c-10.474 0-16.154 5.101-18.607 8.142a15.556 15.556 0 0 0-3.026 5.666H31.07a2 2 0 0 1 0 4z"/>
                        <path d="M25.816 39.617a19.809 19.809 0 1 1 18.665-26.455 2 2 0 0 1-3.767 1.342 15.81 15.81 0 1 0-14.898 21.113 15.67 15.67 0 0 0 6.739-1.503 2 2 0 0 1 1.707 3.618 19.637 19.637 0 0 1-8.446 1.885zM61.666 67.558H26.44a2 2 0 0 1-1.955-1.578c-.578-2.672 1.02-6.932 3.979-10.6 2.902-3.597 9.582-9.632 21.721-9.632 10.383 0 16.776 4.37 20.311 8.034a2 2 0 0 1-2.879 2.778c-2.997-3.107-8.454-6.811-17.432-6.811-10.475 0-16.155 5.103-18.608 8.144a15.546 15.546 0 0 0-3.026 5.665h33.115a2 2 0 0 1 0 4z"/>
                        <path d="M50.185 49.749A19.809 19.809 0 1 1 69.993 29.94a19.83 19.83 0 0 1-19.807 19.809zm0-35.617A15.809 15.809 0 1 0 65.993 29.94a15.827 15.827 0 0 0-15.807-15.808z"/>
                        <path d="M50.084 41.723a10.12 10.12 0 0 1-9.595-6.934 2 2 0 1 1 3.793-1.27 6.107 6.107 0 0 0 11.755-.536 2 2 0 1 1 3.895.91 10.208 10.208 0 0 1-9.848 7.83zM73.315 67.558h-5.322a2 2 0 1 1 0-4h3.322V60.18a2 2 0 0 1 4 0v5.378a2 2 0 0 1-2 2zM25.201 31.59a10.116 10.116 0 0 1-9.594-6.935 2 2 0 0 1 3.793-1.267 6.124 6.124 0 0 0 5.8 4.203 6.582 6.582 0 0 0 6.386-4.45 2 2 0 1 1 3.865 1.03 10.541 10.541 0 0 1-10.25 7.42z"/>
                      </g>
                    </g>
                  </svg>

                  {this.props.iscyoa ? 'Travellers:' : 'Travellers:'}
              </div>

              <div className="column small-7 pax-option text-right">
                <button type="button" className={`${(this.state.Adult === 0) ? "disabled": ""} ${this.props.iscyoa ? 'hide' : ''} `} onClick={e => this.onPassengerChange('adult', 'down')}>
                  <span className="down-button"> &#x2212; </span>
                </button>
                <span className="passengers">
                  <span className="pax-number">{this.state.Adult}</span> Adults
                </span>
                <button type="button" className={`${(this.state.Adult === 10) ? "disabled": ""} ${this.props.iscyoa ? 'hide' : ''} `} onClick={e => this.onPassengerChange('adult', 'up')}>
                  <span className="up-button"> &#x2b; </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )

  }
}


function mapDispatchToProps(dispatch){
  return bindActionCreators({
    SetPassenger
  }, dispatch);
}


export default connect(null, mapDispatchToProps)(PassengerDropdown);



// WEBPACK FOOTER //
// ./src/components/departure/components/passengerdropdown.js